import React from 'react'
import styles from "./CardPreview.module.sass";
import Card from '../Card';
import { AiFillSound } from 'react-icons/ai';
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Pagination } from "swiper";
import { Navigation } from "swiper";
import { useState } from 'react';
import { useEffect } from 'react';

const CardPreview = ({ card, grammar, classificator }) => {

    const [audioUrl, setAudioUrl] = useState('')

    const handleTextToSpeech = (text) =>{
        var msg = new SpeechSynthesisUtterance();
        msg.text = text;
        msg.lang = 'zh';
        window.speechSynthesis.speak(msg);
    }

    const handleListenAudio = (urlProp) =>{

        let url = audioUrl

        if(urlProp){
            url = urlProp
        }
        const request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'blob';
        
        request.onload = function() {
          if (request.status === 200) {
            const blob = request.response;
            const audio = new Audio(URL.createObjectURL(blob));
            audio.play();
          }
        };
        
        request.send();
    }


    useEffect(() => {
        setAudioUrl(card?.examples?.[0]?.audioOld || card?.examples?.[0]?.audioUrl)
    }, [card])
    

    return (
        <Card
            title="Card preview"
            classTitle="title-blue"
        >
            {card &&
                <div className={styles["card-board"]}>
                    <div className={styles["flex-board"]}>
                        <span className={styles.character}>
                            {card?.meaning?.character}
                        </span>
                        <div>
                            <div>
                                <span className={styles.metaLabel}>TP</span>
                                <span className={styles.pinyin}>{card?.meaning?.pinyin}</span>
                            </div>
                            <div>
                                <span className={styles.metaLabel}>TP</span>
                                <span className={styles.grammar}>{grammar || card?.grammars?.[0]?.title}</span>
                            </div>
                            <div>
                                <span className={styles.metaLabel}>CL</span>
                                <span className={styles.grammar}>{classificator || card?.classifications?.[0]?.trans}</span>
                            </div>
                        </div>
                        <div 
                            className={styles.soundBtn}
                            onClick={()=>handleListenAudio(card?.meaning?.audioOld || card?.meaning?.audioUrl)}
                        >
                            <AiFillSound size="20" />
                        </div>
                    </div>
                    <div className={styles.meaningBox}>
                        {card?.meaning?.trans || card?.meaning?.translations?.find(c => c?.lang === 'en')?.trans}
                    </div>
                    <div>
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: 'center'}}>
                            <span className={styles.examplesLabel}>EXAMPLES</span>
                            <div 
                                className={styles.soundBtn}
                                onClick={()=>handleListenAudio()}
                            >
                                <AiFillSound size="20" />
                            </div>
                        </div>
                        <Swiper
                            pagination={true} 
                            modules={[Pagination, Navigation]} 
                            spaceBetween={20} 
                            initialSlide={0}
                            onSlideChange={(e) => setAudioUrl(card?.examples?.[e?.activeIndex]?.audioOld  || card?.examples?.[e?.activeIndex]?.audioUrl)}
                            loop={true}
                        >
                            {card?.examples?.map((example, index)=>(
                                <SwiperSlide key={index}>
                                    <div>
                                        <div className={styles.exampleLine} style={{ fontSize: 18 }}>
                                            {example?.character}
                                        </div>
                                        <div className={styles.exampleLine} style={{ fontSize: 16 }}>
                                            {example?.pinyin}
                                        </div>
                                        <div className={styles.exampleText} style={{ fontSize: 16 }}>
                                            {example?.trans}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            }
        </Card>
    );
}

export default CardPreview;